export default __webpack_public_path__ + "static/media/search.687a3e3b.png";